import React from "react";

function Hamburger() {
  return (
    <>
      <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M30.6243 10.2083H4.37435C3.49935 10.2083 2.91602 9.625 2.91602 8.75C2.91602 7.875 3.49935 7.29167 4.37435 7.29167H30.6243C31.4993 7.29167 32.0827 7.875 32.0827 8.75C32.0827 9.625 31.4993 10.2083 30.6243 10.2083Z" fill="#FFED00" />
        <path d="M30.6243 18.9583H4.37435C3.49935 18.9583 2.91602 18.375 2.91602 17.5C2.91602 16.625 3.49935 16.0417 4.37435 16.0417H30.6243C31.4993 16.0417 32.0827 16.625 32.0827 17.5C32.0827 18.375 31.4993 18.9583 30.6243 18.9583Z" fill="#FFED00" />
        <path d="M30.6243 27.7083H4.37435C3.49935 27.7083 2.91602 27.125 2.91602 26.25C2.91602 25.375 3.49935 24.7917 4.37435 24.7917H30.6243C31.4993 24.7917 32.0827 25.375 32.0827 26.25C32.0827 27.125 31.4993 27.7083 30.6243 27.7083Z" fill="#FFED00" />
      </svg>
    </>
  );
}

export default Hamburger;
